import React from "react";
import { Form } from "react-bootstrap";

const TextareaWithLabel = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  disabled = false,
  required = false,
  className = "",
  rows,
  error, // Accept error message as prop
}) => {
  return (
    <Form.Group className={`mb-3 ${className}`}>
      <Form.Label htmlFor={name} className="cmn_label">
        {label} {required && <span className="text-danger">*</span>}
      </Form.Label>
      <Form.Control
        as="textarea"
        id={name}
        name={name}
        value={value ?? ""}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        rows={rows}
        className={`${disabled ? "disabled_input" : "cmn_input"}`}
      />
      {error && <p className="text-danger">{error}</p>}
    </Form.Group>
  );
};

export default TextareaWithLabel;
